import $ from 'jquery';
import { tl_format } from '../common/constants';

export default function() {
    handleLiveSearch();
    $('.js-big-search-toggle').on('click', function(e) {
        e.preventDefault();
        $('.js-header-search-wrapper').toggleClass('active')
    })
}

function handleLiveSearch() {
    $('body').on('click', function (e) {
        if (
            $(e.target).closest('.ps-form--search-header') ||
            e.target.className === '.ps-form--search-header'
        ) {
            $('.ps-panel--search-result').removeClass('active');
        }
    });
    $('#input-search').on('keyup', function (e) {
        
        if(e.which == 27 || e.which == 91 || e.which == 93 ||  e.which == 18 || e.which == 17 || e.which == 16 || e.which >= 37 && e.which <= 40)
        {
            e.preventDefault();
            return;
        }

        const term = $(this).val();
        const token = $(this).closest('form').find('[name=_token]').val();
        
        if(term.length <= 3)
        {
            $('.js-search-results').html('');
        }

        if(term.length >= 3)
        {
            $('.ps-panel--search-result').addClass('active');

            $.ajax({
                url: window.GLOBALS.baseLink + 'autocomplete',
                type: 'POST',
                data: {Term: term, Token: token},
                dataType: 'json',
                success: function (response) {
                    if (response) {
                        if (response.IsSuccess) {
                            $('.js-search-results').html('');
                            if(response.Products)
                            {
                                $.each(response.Products, function(i, e){
                                    const template = `
                                    <div class="ps-product ps-product--wide ps-product--search-result">
                                        <div class="ps-product__thumbnail">
                                            <a href="${window.GLOBALS.baseLink}urun/${e.Slug}">
                                                <img src="${e.Image}" alt="${e.Title}" />
                                            </a>
                                        </div>
                                        <div class="ps-product__content">
                                            <a class="ps-product__title" href="${window.GLOBALS.baseLink}urun/${e.Slug}">
                                                ${e.Title}
                                            </a>
                                            <p class="ps-product__price">
                                                ${tl_format(e.Price)} TL
                                            </p>
                                        </div>
                                    </div>
                                    `;
                                    $('.js-search-results').append(template);
                                });

                                $('.js-search-all-products').attr('href', `${window.GLOBALS.baseLink}ara?term=${term}`);
                            }
                        } else {
                            console.log('false');
                        }
                    }
                }
            })
        }

        

    })
}